export enum VisaLetterType {
  GlobalConference = 'GlobalConference',
  MDRTAnnualMeeting = 'MDRTAnnualMeeting',
  TOTAnnualMeeting = 'TOTAnnualMeeting',
}
